'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, useContext } from 'react';
import { type DepartureSubPageContextValue, useDepartureSubPageController } from './departure-sub-page-provider.logic.ts';
import { DepartureSubPageSkeleton } from './departure-sub-page-skeleton.tsx';
const DepartureSubPageContext = createContext<DepartureSubPageContextValue | null>(null);
export const useDepartureSubPage = () => {
  const context = useContext(DepartureSubPageContext);
  if (!context) {
    throw new Error("useDepartureSubPage must be used within DepartureSubPageProvider.");
  }
  return context;
};
export const DepartureSubPageProvider: React.FC<{
  children: ReactNode;
}> = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const {
    contextValue,
    isPagePending
  } = useDepartureSubPageController();
  if (isPagePending) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <DepartureSubPageSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== children || $[2] !== contextValue) {
    t1 = <DepartureSubPageContext value={contextValue}>{children}</DepartureSubPageContext>;
    $[1] = children;
    $[2] = contextValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};